import type { Mouvement, Sens } from '@mairistem/comptabilite';
import type React from 'react';
import TypologiesPesComponent from '../../../components/Mouvement/Panel/TypologiesPesComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';
import MouvementPanel from './MouvementPanel';

class TypologiePesPanel extends MouvementPanel {
	constructor(isMandatory = false) {
		super(isMandatory);
		this.code = CODE_PANEL.TYPOLOGIE_PES;
		this.icon = { name: 'crosshairs' };
	}

	getLibelle = () => 'Typologie PES';

	isEmpty = (data: Mouvement) => !data?.naturePiece && !data?.typePiece;

	isComplete = (data: Mouvement) =>
		this.allPresent(data.naturePiece, data.typePiece);

	getComponent = function getComponent(
		data: PanelComponentProps['data'],
		onChange: PanelComponentProps['onChange'],
		handlePin: PanelComponentProps['handlePin'],
		sens: Sens,
		...rest: any
	): React.ReactElement {
		return (
			<TypologiesPesComponent
				data={data}
				handlePin={handlePin}
				onChange={onChange}
				panel={this}
				sens={sens}
				{...rest}
			/>
		);
	};
}

export default TypologiePesPanel;
